import { SelectionList, Tooltip } from '@dixa/lib-shared-habla';
import { HookFormSelectionListSingle } from 'lib-shared-hook-form';
import { Control } from 'react-hook-form';

import { ratingApi } from 'apis/rating';

import type { FormValues } from '../composeEmailModal.types';

type Props = {
  control: Control<FormValues>;
  fromEmailValue: string | null;
};

export function ComposeEmailFieldCsatLanguage({
  control,
  fromEmailValue,
}: Props): JSX.Element {
  const { data, isFetching } = ratingApi.useReadSatisfactionLanguagesQuery(
    { channel: 'email', contactPoint: fromEmailValue ?? '' },
    { skip: !fromEmailValue },
  );
  const satisfactionLanguages = data?.data.languages ?? [];

  return (
    <Tooltip
      content={
        !fromEmailValue
          ? 'Select a From email first'
          : 'No rating languages configured for this email integration'
      }
      disabled={
        !!fromEmailValue && (isFetching || satisfactionLanguages.length > 0)
      }
      requireClick
    >
      <HookFormSelectionListSingle
        name="satisfactionLanguage"
        control={control}
        label="CSAT language"
        disabled={
          !fromEmailValue || isFetching || satisfactionLanguages.length === 0
        }
        componentProps={{
          icon: 'smile',
          placeholder: isFetching ? 'Loading...' : 'None',
          getItemTitleByValue: (lang) => lang,
        }}
      >
        {satisfactionLanguages.map((lang) => (
          <SelectionList.Item key={lang} value={lang}>
            {lang}
          </SelectionList.Item>
        ))}
      </HookFormSelectionListSingle>
    </Tooltip>
  );
}
